import {
    ManagedWorkQueueAcceptedJob,
    ManagedWorkQueueItem
} from '../models/managedWorkQueues/ManagedWorkQueue';

export type ManagedLocationOperationStatus = 'Queued' | 'Syncing...' | 'Publishing...' | 'Complete' | 'Failed';

const terminalStates = new Set(['Complete', 'Failed']);

export const getManagedLocationOperationStatus = (
    acceptedJobs: ManagedWorkQueueAcceptedJob[],
    queueJobs: ManagedWorkQueueItem[]
): ManagedLocationOperationStatus => {
    if (acceptedJobs.length === 0) return 'Failed';

    const queueJobsById = new Map(queueJobs.map(job => [job.id, job]));
    const trackedJobs = acceptedJobs
        .map(job => queueJobsById.get(job.queueJobId))
        .filter((job): job is ManagedWorkQueueItem => !!job);

    if (trackedJobs.some(job => job.state === 'Failed')) return 'Failed';
    if (trackedJobs.length === acceptedJobs.length && trackedJobs.every(job => job.state === 'Complete')) return 'Complete';
    if (trackedJobs.some(job => (job.queueType === 'Backup' || job.queueType === 'Publish') && (job.state === 'Dispatched' || job.state === 'Processing'))) return 'Publishing...';
    if (trackedJobs.some(job => job.queueType === 'ModuleSync' && (job.state === 'Dispatched' || job.state === 'Processing'))) return 'Syncing...';
    return 'Queued';
};

export const areManagedJobsTerminal = (
    acceptedJobs: ManagedWorkQueueAcceptedJob[],
    queueJobs: ManagedWorkQueueItem[]
): boolean => {
    if (acceptedJobs.length === 0) return true;
    const queueJobsById = new Map(queueJobs.map(job => [job.id, job]));
    return acceptedJobs.every(job => {
        const queueJob = queueJobsById.get(job.queueJobId);
        return !!queueJob && terminalStates.has(queueJob.state);
    });
};
